﻿var header = (function ($, headerConfig, undefined) {
	"use strict";
	var obj = {},
		instance,
		suppressAssetInjection = headerConfig && headerConfig.suppressAssetInjection,
		cssAssetsRequested = false,
		jsAssetsRequested = false,
		badgeCookieName = 'navbadges',
		settings = {
			'isLoggedIn': false,
			'dnaUrl': '//dna.ancestry.com',
			'ajaxUrl': '//navigation.ancestry.com/ajax/userdata/2.1',
			'hintsAjaxUrl': '//navigation.ancestry.com/ajax/Hints',
			'messagesAjaxUrl': '//navigation.ancestry.com/ajax/Messages',
			'treesAjaxUrl ': '//navigation.ancestry.com/ajax/Trees',
			'dnaNotificationsAjaxUrl ': '//navigation.ancestry.com/ajax/DnaNotifications',
			'userAjaxUrl ': '//navigation.ancestry.com/ajax/UserInfo',
			'selectedTabName': false,
			'jQueryTimeout': 10000,
			'cookieDomain': 'ancestry.com',
			'cacheDomain': '//c.mfcreative.com'
		},
		lastRequestedTime = {},
		templates = null;
	function ajax(options) {
		if (options.testResponse) {
			setTimeout(function () {
				options.success(options.testResponse);
			}, settings.testing.ajaxDelay || 500);
		} else {
			$.ajax($.extend({}, {
				'dataType': 'jsonp',
				'cache': false,
				'timeout': settings.jQueryTimeout
			}, options));
		}
	}
	function bindBusEvents() {
		if (window.acom && window.acom.bus) {
			window.acom.bus.on('PersonHintTab::hintcount_change::pending', function () {
				header.updateUserData('hints');
			});
		} else {
			setTimeout(function () {
				if (window.acom && window.acom.bus) {
					window.acom.bus.on('PersonHintTab::hintcount_change::pending', function () {
						header.updateUserData('hints');
					});
				}
			}, 500);
		}
	}
	/* This method exists to mock a server-side load of the DNA menu items until a true server-side caching method is implemented. */
	function bindDnaLoad() {
		if (!settings.isLoggedIn || $('#navDna').attr('aria-haspopup') !== 'true') {
			return;
		}
		function loadDna(e) {
			$('#nav, #navDnaMenu').off('.nav.dna');
			loadSubMenu(settings.dnaUrl + '/rest/headerinfo', renderDna, 'dna');
		};
		$('#nav').one('focusin.nav.dna mouseenter.nav.dna', '#navDna', loadDna);
		$('#navDnaMenu').one('focusin.nav.dna mouseenter.nav.dna touchstart.nav.dna', loadDna);
		/* focusin is for ATs on mobile. mouseenter is for desktop screens scaled down. touchstart is for default mobile interactions. */
	}
	function bindEvents() {
		bindSubMenus();
		bindSkipLink();
		bindBusEvents();
		bindOutlineFix();
		bindLanguageToggle();
		bindDnaLoad();
	}
	function bindExpertWarning() {
		$('#nav').on('click.nav', 'a[href*="//www.progenealogists.com"]', expertWarning);
		$('#nav a[href*="//www.progenealogists.com"]').on('click.nav', expertWarning);
	}
	function bindLanguageToggle() {
		$('.navLanguageToggle').on('click', function () {
			var languageId = $(this).data('language-id'),
				languageName = $(this).data('language-name'),
				daysToExpiration = 3560; /* 10 Years */
			setDictionaryCookie('VARS', 'LCID', languageId, null, daysToExpiration);
			setDictionaryCookie('VARS', 'LCISONAME', languageName, null, daysToExpiration);
			var windowLoc = '' + window.location,
				newWindowLoc = windowLoc.replace(/lcid=\d{4}/ig, 'lcid=' + languageId);
			if (windowLoc === newWindowLoc) {
				window.location.reload();
			} else {
				window.location = newWindowLoc;
			}
		});
	}
	function bindOutlineFix() {
		var $body = $('body');
		function usingKeyboard(e) {
			if (e.which === 9) {
				$body
					.removeClass('mouseEvents')
					.off('keydown.outline')
					.one('mousedown.outline', usingMouse);
			}
		}
		function usingMouse() {
			$body
				.addClass('mouseEvents')
				.on('keydown.outline', usingKeyboard);
		}
		$body.one('mousedown.outline', usingMouse);
	}
	function bindSeeMoreDnaButton() {
		$('#navSeeMoreDnaNotifications')
			.off('click.nav')
			.on('click.nav', function () {
				var $navDnaNotificationsList = $('#navDnaNotificationsList'),
					$lastVisibleItem = $navDnaNotificationsList.find('.navListItem:visible').last();
				$navDnaNotificationsList.find('.navListItem').addClass('navShowListItem');
				$lastVisibleItem
					.next()
					.find('a')
					.addClass('navHideHighlight')
					.focus()
					.one('focusout', function () {
						$(this).removeClass('navHideHighlight');
					});
				handleDisplayOfSeeMoreDnaButton();
			});
	}
	function bindSkipLink() {
		/* Workaround for IE 11 choking on the "Skip to navigation link". */
		$('#nav').on('keydown.nav', '#navSkip', function (e) {
			var $target = $($(this).attr('href'));
			if (e.keyCode === 13 || e.keyCode === 32) {
				if (!$target.attr('tabindex')) {
					$target.attr('tabindex', '-1').one('blur.nav', function () {
						$target.removeAttr('tabindex');
					});
				}
				$target.focus();
				return false;
			}
		});
	}
	function bindSubMenus() {
		var $window = $(window);
		$window.on('resize.nav', debounce(function () {
			destroyHiddenSubMenus();
			initCalloutSubMenus();
		}, 200));
		initSubMenus();
	}
/*
	function bindCartTracking() {
		$('#navCartCheckout, #navCartEmpty').on('click', function () {
			fireTracking('Header Cart : ' + $(this).data('tracking-name'));
		});
	}
*/
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	}
/*
	function fireTracking(trackingName) {
		if (!window.sc_npv) {
			console.warn('Omniture Unavailable : ' + trackingName);
		} else if (window.sc_npv) {
			window.sc_npv('eVar70', trackingName, 0);
		}
	}
*/
	function clearHints() {
		var options = {
			'url': settings.hintsClearAllUrl + '?customerId=' + settings.userId,
			'success': function (data) {
				if (data) {
					$('#navHints').find('.badge').fadeOut(function () {
						$(this).addClass('noDisplay').css('display', '');
					});
				}
			}
		};
		ajax(options);
	}
	function clearCart() {
		var options = {
			'url': settings.clearCartUrl + '?customerId=' + settings.userId,
			'success': function (data) {
				if (data) {
					$('#navCart').remove();
					$('.navSecondaryMenu .navEmphasizedButton').removeClass('noDisplay');
				}
			}
		};
		ajax(options);
	}
	function clearDnaNotifications() {
		$('#navDnaNotifications').find('.badge').fadeOut(function () {
			$(this).addClass('noDisplay').css('display', '');
		});
	}
	function correctDomLocation() {
		var $HeaderRegion = $('#HeaderRegion');
		if ($HeaderRegion.closest('#GlobalWrpr').length && $('body').outerWidth() > $HeaderRegion.outerWidth()) {
			$HeaderRegion.insertBefore('#GlobalWrpr');
		}
		/* Remove fixed heights from pages incorrectly setting these as inline values */
		$HeaderRegion.css({'height': '', 'min-height':''});
	}
	function destroyHiddenSubMenus() {
		$('#nav .initialized[aria-owns]:not(:visible)')
			.removeClass('initialized')
			.off('keyup.nav keydown.nav')
			.callout('destroy');
	}
	function expertWarning(e) {
		var $progenLogo = $('div.navProgenLogo');
		if ($progenLogo.length) {
			$progenLogo.replaceWith('<img class="navProgenLogo" alt="' + $progenLogo.data('alt') + '" src="' + $progenLogo.data('src') + '" />');
		}
		$('#progenLeavingAncestryModal').modal({
			'width': 500
		});
		e.preventDefault();
	}
	function getDateHtml(birth, death) {
		if (birth && death) {
			return '<em>' + birth + ' - ' + death + '</em>';
		}
		if (birth) {
			return '<em>' + birth + '</em>';
		}
		if (death) {
			return '<em>' + death + '</em>';
		}
		return '';
	}
	function getCss() {
		var url = settings.cacheDomain + '/lib/tgn/combo.ashx',
			unloadedCount = 0,
			divider = '?x',
			loaded = '',
			core = '/css/core.css',
			needed = [
				'/css/v1/main.css',
				'/css/v2/alert.css',
				'/css/v1/button.css',
				'/css/v1/callout.css',
				'/css/v1/icon.css',
				'/css/v3/modal.css',
				'/css/v1/user-card.css'
			];
		cssAssetsRequested = true;
		$('link[href*=".css"]').each(function () {
			loaded += $(this).attr('href').toLowerCase();
		});
		if (loaded.indexOf(core) !== -1) {
			return; /* core.css includes all needed assets */
		}
		$.each(needed, function (i, value) {
			if (loaded.indexOf(value) === -1) {
				url += divider + value;
				divider = '&x';
				unloadedCount++;
				warn(value);
			}
		});
		if (unloadedCount > 0) {
			$('head').append('<link href="' + url + '" rel="stylesheet" />');
		}
	}
	function getJs() {
		var url = settings.cacheDomain + '/lib/tgn/combo.ashx',
			unloadedCount = 0,
			divider = '?x',
			loaded = '',
			core = '/js/core.js',
			needed = [
			'/js/v1/callout.js',
			'/js/v3/modal.js'
			];
		$('script[src]').each(function () {
			loaded += $(this).attr('src');
		});
		jsAssetsRequested = true;
		if (loaded.indexOf(core) !== -1) {
			return; /* core.js includes all needed assets */
		}
		$.each(needed, function (i, value) {
			if (loaded.indexOf(value) === -1) {
				url += divider + value;
				divider = '&x';
				unloadedCount++;
				warn(value);
			}
		});
		if (unloadedCount > 0) {
			$('<script />', {src: url}).appendTo('head');
		}
	}
	function initCalloutSubMenus() {
		$('#nav [aria-owns]:visible:not(.initialized)')
			.addClass('initialized link')
			.each(function () {
				var $this = $(this),
					hasUnviewedBadge,
					badgeTimer,
					submenuId = '#' + $this.attr('aria-owns'),
					$submenu = $(submenuId),
					classes = 'calloutMenu navCalloutMenu',
					isBadgeable = $this.hasClass('navMainLink'),
					isHintsMenu = $this.hasClass('navHints'),
					isCartMenu = $this.hasClass('navCart'),
					isDnaNotificationsMenu = $this.hasClass('navDnaNotifications'),
					allowClick = !$this.closest('.navSecondaryMenu').length;
				$this.callout({
					'allowClick': allowClick,
					'content': $submenu,
					'classes': classes,
					'hideDelay': 500,
					'disableAutofocusOnOpen': true,
					'onOpen': function ($trigger) {
						var $badge = $trigger.find('.badge:visible');
						hasUnviewedBadge = $badge.length;
						$trigger
							.add($submenu)
							.attr('aria-expanded', true);
						if (settings.isLoggedIn) { // && !$trigger.data('already-loaded')) {
							obj.updateUserData(submenuId.toLowerCase().replace('#nav', '').replace('menu', ''));
							$trigger.data('already-loaded', true);
						}
						if (isBadgeable && settings.isLoggedIn) {
							if (hasUnviewedBadge) {
								badgeTimer = setTimeout(function () {
									$submenu.find('.badge').attr('data-badge-viewed', true);
									$badge.animate({
										'margin-right': -($badge.outerWidth()),
										'opacity': 0
									}, function () {
										$(this).remove();
									})
									.prev('.navSpacer')
									.animate({'margin-right': -($badge.prev('.navSpacer').outerWidth())}, function () {
										$(this).remove();
									});
									setBadgeCookie();
								}, 1000);
							}
							$submenu
								.off('click.nav.badge')
								.on('click.nav.badge', 'a:has(.badge[data-badge-viewed])', function () {
									$(this).find('.badge[data-badge-viewed]').attr('data-badge-clicked', true);
									setBadgeCookie();
								});
						}
						if (isCartMenu) {
							$('#navCartEmpty').on('click.nav', function () {
								$trigger.callout('close');
								clearCart();
							});
							// fireTracking('Header Cart : Opened');
						} else if (isHintsMenu && hasUnviewedBadge) {
							badgeTimer = setTimeout(clearHints, 3000);
						} else if (isDnaNotificationsMenu && hasUnviewedBadge) {
							badgeTimer = setTimeout(clearDnaNotifications, 3000);
						}
					},
					'onClose': function ($trigger) {
						$trigger
							.add($submenu)
							.attr('aria-expanded', false);
						if (hasUnviewedBadge) {
							clearTimeout(badgeTimer);
						}
						if (isCartMenu) {
							$('#navCartEmpty').off('click.nav');
						}
					}
				});
				$this.on('keyup.nav', function (e) {
					if (e.keyCode === 32) {
						$this.callout('open');
					}
				});
				/* Store trigger onto submenu for easy reuse. */
				$submenu.data('$trigger', $this);
			})
			.on('keydown.nav', function (e) {
				var $this = $(this),
					$subMenuItems = $('.' + $this.attr('aria-owns')).find('a:visible');
				if (e.keyCode === 40 || e.keyCode === 32) {
					$subMenuItems.first().focus();
					return false;
				} else if (e.keyCode === 38) {
					$subMenuItems.last().focus();
					return false;
				} else if (e.keyCode === 32 && $this.data('submenu-type') !== 'hover') {
					$this.callout('open');
					return false;
				}
			});
	}
	function initSubMenus() {
		var $nav = $('nav');
		var navVersion = $nav.data('nav-version');
		$nav.find('.navSubMenu').addClass(navVersion);
		initCalloutSubMenus();
		$nav.on('focusout.nav', function () {
			var $activeCalloutTrigger = $('.calloutTrigger.active');
			setTimeout(function () {
				if (!$(':focus').closest('.calloutContent').length && $activeCalloutTrigger.hasClass('active') && $(':focus').length) {
					$activeCalloutTrigger.callout('close');
				}
			}, 200);
		});
		$('.navSubMenu').on('keydown.nav', 'a, .link', function (e) {
			if ($(this).closest('.navMobileMenu').length) {
				return;
			}
			return handleKeyboardNavigation(e, $(this), $(this).closest('.navSubMenu'));
		});
		$('.navMobileMenu')
			.on('keydown.nav', 'a', function (e) {
				return handleKeyboardNavigation(e, $(this), $(this).closest('.navMobileMenu'));
			})
			.on('click.nav expandSubMenu.nav', '.calloutMenuTitle', function () {
				$(this)
					.closest('.navSubMenu')
					.toggleClass('navSubMenuExpanded')
					.siblings('.navSubMenu')
					.removeClass('navSubMenuExpanded');
			});
		if (settings.isLoggedIn) {
			$('#navSeeAllHintsIn').on('click.nav', function () {
				var $trigger = $(this),
					$navSeeAllHintsMenu = $('#navSeeAllHintsMenu');
				if ($navSeeAllHintsMenu.hasClass('noDisplay')) {
					$trigger.attr('aria-expanded', true);
					$navSeeAllHintsMenu.removeClass('noDisplay');
				} else {
					$trigger.attr('aria-expanded', false);
					$navSeeAllHintsMenu.addClass('noDisplay');
				}
			});
		}
	}
	function jsIsLoaded() {
		if ($.callout && $.modal) {
			return true;
		}
		return false;
	}
	function getStaticAssets() {
		if (suppressAssetInjection) {
			return true;
		}
		if (!cssAssetsRequested) {
			getCss();
		}
		if (!jsAssetsRequested) {
			getJs();
		}
		if (cssAssetsRequested && jsIsLoaded()) {
			return true;
		}
		return false;
	}
	function getCookie(name) {
		var i,
			cookie,
			cookieName = name + '=',
			cookies = document.cookie.split(';');
		for (i = 0; i < cookies.length; i++) {
			cookie = cookies[i];
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1);
			}
			if (cookie.indexOf(cookieName) === 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}
		return '';
	}
	function getDictionaryCookie(cookieName, entryName) {
		var i,
			values,
			cookie = getCookie(cookieName);
		if (!cookie.length) {
			return '';
		}
		values = cookie.split('&');
		entryName = entryName + '=';
		for (i = values.length - 1; i >= 0; i--) {
			if (values[i].indexOf(entryName) !== -1) {
				return values[i].substr(values[i].indexOf(entryName) + (entryName.length));
			}
		}
		return '';
	}
	function setCookie(cookieName, value, daysUntilExpiration) {
		var d, expires;
		d = new Date();
		d.setTime(d.getTime() + (daysUntilExpiration * 24 * 60 * 60 * 1000));
		expires = "expires=" + d.toUTCString();
		var domain = (settings.cookieDomain[0] === '.' ? '' : '.') + settings.cookieDomain;
		document.cookie = cookieName + "=" + value + "; " + expires + ";domain=" + domain + ";path=/";
	}
	function deleteCookie(cookieName) {
		document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	}
	function setDictionaryCookie(cookie_name, key, value, path, daysUntilExpiration) {
		cookie_name = cookie_name.toUpperCase();
		key = key.toUpperCase();
		var dict_src,
			start_key,
			end_key,
			dictionary = getCookie(cookie_name);
		if ((dictionary === null) || (dictionary === undefined)) {
			dictionary = key + "=" + value;
		} else {
			dict_src = dictionary.toLowerCase();
			start_key = dict_src.indexOf(key.toLowerCase() + "=");
			if (start_key === -1) { // key was not there
				if (dictionary.length > 0) {
					dictionary = dictionary + "&";
				}
				dictionary = dictionary + key + "=" + value;
			}
			else {
				end_key = dict_src.indexOf("&", start_key);
				if (end_key === -1) { // no keys after
					if (start_key === 0) { // no keys before no keys after
						dictionary = key + "=" + value;
					} else { // keys before not after
						dictionary = dictionary.substring(0, start_key) + key + "=" + value;
					}
				} else { // key is somewhere in middle
					dict_src = dictionary;
					dictionary = "";
					if (start_key > 0) { // keys before
						dictionary = dict_src.substring(0, start_key);
					}
					dictionary = dictionary + key + "=" + value;
					dictionary = dictionary + dict_src.substring(end_key);
				}
			}
		}
		setCookie(cookie_name, dictionary, daysUntilExpiration);
	}
	function setBadgeCookie() {
		var badges = retrieveBadgesFromCookie() || {},
			newViewedBadgeIds = [],
			newClickedBadgeIds = [];
		$('.navSubMenu').find('.badge[data-badge-id]').each(function() {
			var $this = $(this);
			if ($this.attr('data-badge-viewed')) {
				newViewedBadgeIds.push($this.attr('data-badge-id'));
			}
			if ($this.attr('data-badge-clicked')) {
				newClickedBadgeIds.push($this.attr('data-badge-id'));
			}
		});
		if (!newViewedBadgeIds.length && !newClickedBadgeIds.length) {
			deleteCookie(badgeCookieName);
		} else {
			badges[settings.userId] = {};
			if (newViewedBadgeIds.length) {
				badges[settings.userId].viewed = newViewedBadgeIds;
			}
			if (newClickedBadgeIds.length) {
				badges[settings.userId].clicked = newClickedBadgeIds;
			}
			setCookie(badgeCookieName, JSON.stringify(badges), 90);
		}
	}
	function retrieveUserBadgesFromCookie() {
		var badges = retrieveBadgesFromCookie();
		if (badges[settings.userId]) {
			badges = badges[settings.userId];
		} else {
			badges = false;
		}
		return badges;
	}
	function retrieveBadgesFromCookie() {
		var badges = getCookie(badgeCookieName);
		if (badges.length) {
			badges = JSON.parse(badges);
		} else {
			badges = false;
		}
		return badges;
	}
	function handleKeyboardNavigation(e, $link, $menu) {
		var $newLink,
			$closestSubMenu,
			isMobileMenu = $menu.hasClass('navMobileMenu'),
			$subMenuItems = $menu.find('a:visible, button:visible'),
			currentIndex = $subMenuItems.index($link),
			subMenuItemsCount = $subMenuItems.length;
		if (e.keyCode === 40) {
			$newLink = $subMenuItems.eq(currentIndex + 1 >= subMenuItemsCount ? 0 : currentIndex + 1);
			if (isMobileMenu) {
				$closestSubMenu = $newLink.closest('.navSubMenu');
				if (!$closestSubMenu.hasClass('navSubMenuExpanded')) {
					$closestSubMenu.find('.calloutMenuTitle').trigger('expandSubMenu.nav');
				}
			}
			$newLink.focus();
			return false;
		} else if (e.keyCode === 38) {
			$newLink = $subMenuItems.eq($subMenuItems.index($link) - 1);
			if (isMobileMenu) {
				$closestSubMenu = $newLink.closest('.navSubMenu');
				if (!$closestSubMenu.hasClass('navSubMenuExpanded')) {
					$closestSubMenu.find('.calloutMenuTitle').trigger('expandSubMenu.nav');
				}
			}
			$newLink.focus();
			return false;
		}
	}
	function handleFailedMenu(loadingSpot) {
		$(loadingSpot).callout('destroy');
	}
	function handleBadges() {
		var now = Date.now(),
			badges = retrieveUserBadgesFromCookie();
		$('#navMobileMenu')
			.find('.navSubMenu')
			.each(function () {
				var $this = $(this),
					count = 0;
				$this.find('.badge').each(function () {
					// If badge not present in cookie and expiration is after now, show badge and increase count
					var $badge = $(this),
						id = $badge.attr('data-badge-id'),
						expiration = Date.parse($badge.attr('data-badge-expiration')),
						countBadge = true;
					if ((badges && badges.viewed && badges.viewed.indexOf(id) !== -1) || expiration <= now) {
						countBadge = false;
						$badge.attr('data-badge-viewed', true);
					}
					if (!badges || (badges && !badges.clicked) || (badges && badges.clicked && badges.clicked.indexOf(id) === -1)) {
						if (expiration > now) {
							$badge.removeClass('noDisplay');
						}
					} else {
						$badge.attr('data-badge-clicked', true);
					}
					if (countBadge) {
						count++;
					}
				});
				if (count > 0) {
					$('#' + $this.attr('aria-labelledby'))
						.children('.badge')
						.remove()
						.end()
						.append(' ' + templates.templateBadge.replace('{text}', count));
				}
			});
	}
	function loadSubMenu(url, callback, key) {
		var currentTime = Date.now(),
			timeBetweenRequests = 5000,
			options = {
				'url': url,
				'success': callback,
				'error': callback
			};
		if (settings.testing) {
			options.testResponse = settings.testing[key];
		}
		/* Debounce menus from being requested multiple times in rapid succession */
		if (currentTime > (lastRequestedTime[key] || 0) + timeBetweenRequests) {
			lastRequestedTime[key] = currentTime;
			ajax(options);
		}
	}
	function renderUsername(username, userImage) {
		var $accountImage = $('#navAccountImage'),
			$mobileAccountImage = $('#navAccountMobileImage'),
			$accountUsernames = $('#navAccountUsername, #navAccountMobileUsername');
		if (userImage) {
			$accountImage.replaceWith('<span class="userCardImg userCardImgCenter" id="navAccountImage" style="background-image:url(\'' + userImage + '\');"><img class="navUserImage" src="' + userImage + '" alt="' + username + '" /></span>');
			$mobileAccountImage.replaceWith('<div aria-hidden="true" class="userCardImg" id="navAccountMobileImage"><img src="' + userImage + '" alt="' + username + '" /></div>');
		} else {
			$accountImage.replaceWith('<span class="userCardImg icon iconPerson" id="navAccountImage"></span>');
			$mobileAccountImage.replaceWith('<div aria-hidden="true" class="userCardImg icon iconPerson" id="navAccountMobileImage"></div>');
		}
		$accountUsernames.html(username);
	}
	function renderUpsellLink(url, text, isFullAccessFreeTrialer) {
		var $expertLink = $('#navLinkExpert');
		$('.navSecondaryMenu, .navMobileMenu').children('.navEmphasizedButton, .navEmphasizedTitle, .navEmphasizedExpertButton').remove();
		if (!url && !isFullAccessFreeTrialer && $expertLink.length) {
			/*	If they have World Explorer Plus AND
				They are not free trialers AND
				ProGen is available in their area, show the progen link as a button. */
			url = $expertLink.attr('href');
			text = $expertLink.text();
			$('.navSecondaryMenu').prepend(templates.templateEmphasizedButton.replace('{url}', url).replace('{text}', text).replace('navEmphasizedButton', 'navEmphasizedExpertButton'));
		} else if (url) {
			$('.navSecondaryMenu').prepend(templates.templateEmphasizedButton.replace('{url}', url).replace('{text}', text));
			$('.navMobileMenu').append(templates.templateEmphasizedMobileButton.replace('{url}', url).replace('{text}', text));
		}
	}
	function updateCartLinks(cart) {
		if (cart) {
			$('#navCartCheckout, #navCart').attr('href', cart[0].checkoutUrl);
			$('#navCart').removeClass('noDisplay');
			$('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton').addClass('noDisplay');
		} else {
			$('#navCart').addClass('noDisplay');
			$('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton').removeClass('noDisplay');
		}
	}
	function objectsAreIdentical(obj1, obj2) {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	function renderDna(data) {
		var i,
			menuLength = 0,
			menuList = '',
			$navDna = $('#navDna'),
			$navDnaMenu = $('.navDnaMenu');
		if (data) {
			data = data.results;
		}
		if (!data || !data.menuitems) {
			return false;
		}
		menuLength = data.menuitems.length;
		for (i = 0; i < menuLength; i += 1) {
			menuList += '<li><a href="' + data.menuitems[i].url + '">' + data.menuitems[i].text + '</a></li>';
		}
		$navDnaMenu.find('ul').html(menuList);
		if ($navDna.data('calloutInstance')) {
			$navDna.callout('position'); /* Reposition callout since it doesn't have a fixed width */
		}
	}
	function renderTrees(data) {
		var i,
			menuLength = 0,
			menuList = '',
			currentTree,
			isCurrentTree = false,
			$navTrees = $('#navTrees'),
			$navTreesMenu = $('#navTreesMenu');
		// If failed new data and no old data, remove the callout
		if (data.success !== true && !$navTreesMenu.data('currentData')) {
			handleFailedMenu('#navTrees');
			return false;
		}
		// If bad new data, but good old data
		// Or new data is same as old
		if (data.success !== true || objectsAreIdentical($navTreesMenu.data('currentData'), data)) {
			return false;
		}
		$navTreesMenu.data('currentData', data);
		currentTree = data.mostRecentlyViewedTreeId || false;
		menuLength = data.menuitems.length;
		for (i = 0; i < menuLength; i++) {
			isCurrentTree = currentTree && data.menuitems[i].url.indexOf(currentTree) !== -1;
			menuList += '<li><a ' + (isCurrentTree ? 'class="calloutMenuChecked iconAfter iconAfterCheck" ' : '') + 'href="' + data.menuitems[i].url + '">' + data.menuitems[i].text + '</a></li>';
			if (isCurrentTree) {
				$navTrees.attr('href', data.menuitems[i].url);
			}
		}
		$navTreesMenu.find('ul').html(menuList).one('click.nav', 'a', function () {
			ajax({
				'url': settings.clearUserDataUrl + '?trees=true'
			});
		});
		hideLoadingMessageOnSubmenu('#navTreesMenu');
		if ($navTrees.data('calloutInstance')) {
			$navTrees.callout('position'); /* Reposition callout since it doesn't have a fixed width */
		}
	}
	function renderMessages(data) {
		var i,
			menuLength,
			html = '',
			item = '',
			$navMessagesMenu = $('#navMessagesMenu');
		// If failed new data and no old data, remove the callout
		if (data.success !== true && !$navMessagesMenu.data('currentData')) {
			handleFailedMenu('#navMessages');
			return false;
		}
		// If bad new data, but good old data
		// Or new data is same as old
		if (data.success !== true || objectsAreIdentical($navMessagesMenu.data('currentData'), data)) {
			return false;
		}
		$navMessagesMenu.data('currentData', data);
		menuLength = data.menuitems.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				item = templates.templateNotification
					.replace('{url}', data.menuitems[i].url)
					.replace('{unread}', data.menuitems[i].unread ? 'navUnread' : '');
				if (data.menuitems[i].img && data.menuitems[i].img.length) {
					item = item.replace('{image}', templates.templateNotificationUsercardImage.replace('{imageUrl}', data.menuitems[i].img));
				} else {
					item = item.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', 'Person'));
				}
				item = item
					.replace('{title}', data.menuitems[i].username)
					.replace('{badge}', data.menuitems[i].unread ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', data.menuitems[i].text)
					.replace('{meta}', data.menuitems[i].date + ', ' + data.menuitems[i].subject);
				html += item;
			}
			$('#navMessagesList').html(html);
			$('#navNoMessages').addClass('noDisplay');
			$('#navHasMessages').removeClass('noDisplay');
		} else {
			$('#navNoMessages').removeClass('noDisplay');
			$('#navHasMessages').addClass('noDisplay');
		}
		hideLoadingMessageOnSubmenu('#navMessagesMenu');
	}
	function renderHints(data) {
		var i,
			meta,
			html = '',
			item = '',
			hintIcon,
			menuLength,
			treesLength,
			$navHintsMenu = $('#navHintsMenu');
		// If failed new data and no old data, remove the callout
		if (data.success !== true && !$navHintsMenu.data('currentData')) {
			handleFailedMenu('#navHints');
			return false;
		}
		// If bad new data, but good old data
		// Or new data is same as old
		if (data.success !== true || objectsAreIdentical($navHintsMenu.data('currentData'), data)) {
			return false;
		}
		$navHintsMenu.data('currentData', data);
		menuLength = data.menuitems.length;
		treesLength = data.trees.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				if (data.menuitems[i].type === 'Person') {
					hintIcon = 'Person';
				} else if (data.menuitems[i].type === 'Photo') {
					hintIcon = 'Image';
				} else if (data.menuitems[i].type === 'Story') {
					hintIcon = 'Story';
				} else { // if (data.menuitems[i].type === 'Record') {
					hintIcon = 'Note';
				}
				meta = getDateHtml(data.menuitems[i].birth, data.menuitems[i].death);
				if (meta.length && treesLength > 1) {
					meta += ', ';
				}
				meta += (treesLength > 1 ? data.menuitems[i].treeName : '');
				item = templates.templateNotification
					.replace('{url}', data.menuitems[i].url)
					.replace('{unread}', data.menuitems[i].unread ? 'navUnread' : '')
					.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', hintIcon))
					.replace('{title}', data.menuitems[i].title)
					.replace('{badge}', data.menuitems[i].unread ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', data.menuitems[i].name)
					.replace('{meta}', meta);
				html += item;
			}
			$('#navHintsList').html(html);
			$('#navNoHints').addClass('noDisplay');
			$('#navHasHints').removeClass('noDisplay');
		} else {
			$('#navNoHints').removeClass('noDisplay');
			$('#navHasHints').addClass('noDisplay');
		}
		if (treesLength > 1) {
			html = '';
			for (i = 0; i < treesLength; i += 1) {
				html += '<li><a href="' + data.trees[i].url + '">' + data.trees[i].text + '</a></li>';
			}
			$('#navSeeAllHintsMenu').html(html);
			$('#navSeeAllHints').addClass('noDisplay');
			$('#navSeeAllHintsIn').removeClass('noDisplay');
		} else {
			$('#navSeeAllHints').removeClass('noDisplay');
			$('#navSeeAllHintsIn').addClass('noDisplay');
		}
		hideLoadingMessageOnSubmenu('#navHintsMenu');
	}
	function renderDnaNotifications(data) {
		var i,
			menuLength,
			gender,
			html = '',
			item,
			genderIcon,
			$navDnaNotificationsMenu = $('#navDnaNotificationsMenu');
		// If failed new data and no old data, remove the callout
		if (data.success !== true && !$navDnaNotificationsMenu.data('currentData')) {
			handleFailedMenu('#navDnaNotifications');
			return false;
		}
		// If bad new data, but good old data
		// Or new data is same as old
		if (data.success !== true || objectsAreIdentical($navDnaNotificationsMenu.data('currentData'), data)) {
			return false;
		}
		$navDnaNotificationsMenu.data('currentData', data);
		menuLength = data.menuitems.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				item = templates.templateNotification
					.replace('{url}', data.menuitems[i].url)
					.replace('{unread}', data.menuitems[i].unread ? 'navUnread' : '');
				if (data.menuitems[i].img) {
					item = item.replace('{image}', templates.templateNotificationUsercardImage.replace('{imageUrl}', data.menuitems[i].img));
				} else {
					gender = (data.menuitems[i].gender || '').toLowerCase();
					if (gender === 'male') {
						genderIcon = 'Male';
					} else if (gender === 'female') {
						genderIcon = 'Female';
					} else {
						genderIcon = 'Person';
					}
					item = item.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', genderIcon));
				}
				item = item
					.replace('{title}', data.menuitems[i].title)
					.replace('{badge}', !data.menuitems[i].visited ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', data.menuitems[i].name)
					.replace('{meta}', data.menuitems[i].date + ', ' + data.menuitems[i].test);
				html += item;
			}
			$('#navDnaNotificationsList').html(html);
			$('#navHasDnaNotifications').removeClass('noDisplay');
			$('#navNoDnaNotifications').addClass('noDisplay');
			bindSeeMoreDnaButton();
			handleDisplayOfSeeMoreDnaButton();
		} else {
			$('#navNoDnaNotifications').removeClass('noDisplay');
			$('#navHasDnaNotifications').addClass('noDisplay');
		}
		hideLoadingMessageOnSubmenu('#navDnaNotificationsMenu');
	}
	function showCount(area, count) {
		var $area = $(area),
			$badge = $area.find('.badge');
		$badge.remove();
		if (count > 0) {
			$badge.html(count > 99 ? '99+' : count).removeClass('noDisplay');
		} else {
			$badge.addClass('noDisplay');
		}
		$badge.appendTo($area);
	}
	function showDnaNotificationIcon() {
		$('#navDnaNotifications').removeClass('noDisplay');
	}
	function showLoadingMessageOnSubmenu(submenuId) {
		$(submenuId + 'Loading').attr('aria-busy', 'true').removeClass('noDisplay');
	}
	function hideLoadingMessageOnSubmenu(submenuId) {
		$(submenuId + 'Loading').attr('aria-busy', 'false').addClass('noDisplay');
	}
	function handleDisplayOfSeeMoreDnaButton() {
		var $hiddenNotifications = $('#navDnaNotificationsList .navListItem:not(:visible)');
		if ($hiddenNotifications.length) {
			$('#navSeeMoreDnaNotifications').removeClass('noDisplay');
		} else {
			$('#navSeeMoreDnaNotifications').addClass('noDisplay');
		}
	}
	function prepareTemplates() {
		if (templates !== null) {
			return;
		}
		templates = {
			'templatesPrepared': true,
			'templateNew': $('#templateNew').html(),
			'templateBadge': $('#templateBadge').html(),
			'templateNotification': $('#templateNotification').html(),
			'templateNotificationTypeIcon': $('#templateNotificationTypeIcon').html(),
			'templateNotificationUsercardIcon': $('#templateNotificationUsercardIcon').html(),
			'templateNotificationUsercardImage': $('#templateNotificationUsercardImage').html(),
			'templateEmphasizedButton': $('#templateEmphasizedButton').html(),
			'templateEmphasizedMobileButton': $('#templateEmphasizedMobileButton').html(),
		};
		$('.navTemplates').remove();
	}
	function renderCachedMenuOrDisplayLoadingMessage(key, menuId, renderingFunction) {
		if (settings.cachedData && settings.cachedData[key] && settings.cachedData[key].success) {
			renderingFunction(settings.cachedData[key]);
		} else {
			showLoadingMessageOnSubmenu('#' + menuId);
		}
	}
	function personalizeHeader() {
		prepareTemplates();
		showLoadingMessageOnSubmenu('#navDnaMenu');
		renderCachedMenuOrDisplayLoadingMessage('trees', 'navTreesMenu', renderTrees);
		renderCachedMenuOrDisplayLoadingMessage('hints', 'navHintsMenu', renderHints);
		renderCachedMenuOrDisplayLoadingMessage('messages', 'navMessagesMenu', renderMessages);
		renderCachedMenuOrDisplayLoadingMessage('dnaNotifications', 'navDnaNotificationsMenu', renderDnaNotifications);
		loadUserInfo();
	}
	function unbindEvents() {
		$('#nav, #nav a[href*="//www.progenealogists.com"], #nav [aria-owns], .navSubMenu, .navMobileMenu, #navSeeAllHintsIn, #username').off('.nav');
	}
	function loadUserInfo(bypassCache) {
		if (!!settings.ajaxUrl) {
			var options = {
				'url': settings.ajaxUrl + (bypassCache ? '?bypassCache=true' : ''),
				'success': function (data) {
					if (data.user) {
						renderUsername(data.user.name, data.user.image);
						renderUpsellLink(data.user.subscribeUrl, data.user.subscribeText, data.user.isFullAccessFreeTrialer);
						if (data.cart) {
							updateCartLinks(data.cart);
							//bindCartTracking();
						}
						showCount('#navMessages', data.messagecount);
						showCount('#navHints', data.hintcount);
						if (data.showDnaNotification) {
							showDnaNotificationIcon();
							showCount('#navDnaNotifications', data.dnaCount);
						}
						initCalloutSubMenus(); /* Needed to init the cart and dna notification menus */
					}
					$('.navSecondaryMenuUnloaded').removeClass('navSecondaryMenuUnloaded');
				}
			};
			if (settings.testing) {
				options.testResponse = settings.testing.userinfo;
			}
			ajax(options);
		}
	}
	function updateQueryStringParameter(uri, key, value) {
		var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i'),
			separator = uri.indexOf('?') !== -1 ? '&' : '?';
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		else {
			return uri + separator + key + '=' + value;
		}
	}
	function warn(name) {
		console.warn('Header Resource Missing : ' + name);
		// fireTracking('Header Resource Missing : ' + name + ' : ' + window.location.hostname + window.location.pathname);
	}
	function initializeHeader() {
		if (!getStaticAssets()) {
			setTimeout(initializeHeader, 200);
			return false;
		}
		correctDomLocation();
		bindEvents();
		obj.setSelectedPage(settings.selectedTabName);
		if (settings.isLoggedIn) {
			personalizeHeader();
			handleBadges();
		}
		if (settings.showHireAnExpertWarning) {
			bindExpertWarning();
		}
	}
	obj.setReturnUrl = function (returnUrl) {
		var $link = $('a#navAccount'),
			href = $link.attr('href');
		href = updateQueryStringParameter(href, 'returnUrl', encodeURIComponent(returnUrl));
		$link.attr('href', href);
	};
	obj.setSelectedPage = function (selectedTab) {
		if (selectedTab) {
			$('.nav')
				.find('.navLinkSelected:not(".nav' + selectedTab + '")')
				.removeClass('navLinkSelected')
				.end()
				.find('.nav' + selectedTab)
				.addClass('navLinkSelected');
		}
	};
	obj.updateUserData = function (key) {
		switch (key) {
			case 'trees':
			case 'mobile':
				loadSubMenu(settings.treesAjaxUrl, renderTrees, 'trees');
				break;
			case 'hints':
				loadSubMenu(settings.hintsAjaxUrl + '?bypassCache=true', renderHints, 'hints');
				break;
			case 'messages':
				loadSubMenu(settings.messagesAjaxUrl + '?bypassCache=true', renderMessages, 'messages');
				break;
			case 'user':
				loadUserInfo(true);
				break;
			case 'dna':
				loadSubMenu(settings.dnaUrl + '/rest/headerinfo', renderDna, 'dna');
				break;
			case 'dnanotifications':
				loadSubMenu(settings.dnaNotificationsAjaxUrl, renderDnaNotifications, 'dnaNotifications');
				break;
		}
	};
	obj.init = function (options) {
		if (instance !== undefined) {
			unbindEvents();
		}
		instance = $.extend(settings, options);
		setTimeout(initializeHeader, 10); /* Needs timeout since callout.js is likely to be loaded after header.js */
		return instance;
	};
	return obj;
}(jQuery, (typeof headerConfig === 'undefined') ? null : headerConfig));
/* Temp for Community/Hints Page */
var AHS = {};
AHS.SetMessagesCount = function () {
	if (window.sc_npv) {
		sc_npv('prop70', 'Header 2.1 : Test : Called AHS.SetMessagesCount', 0);
	}
};
AHS.SetHintsCount = function () {
	if (window.sc_npv) {
		sc_npv('prop70', 'Header 2.1 : Test : Called AHS.SetHintsCount ', 0);
	}
};
